import React, { useRef, useState, useEffect } from 'react';
import InputMask from "react-input-mask";

interface InputProps {
    name: string;
    id: string;
    type: string;
    desc: string;
    required?: boolean;
    mask?: string;
}

const Input: React.FC<InputProps> = ({ name, id, type, desc, mask, required = false }) => {

    const [width, setWidth] = useState<number>(0);
    const textRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (textRef.current) {
        setWidth(textRef.current.getBoundingClientRect().width);
        }
    }, []);

    return (
        <label htmlFor={id} className="block text-sm w-full relative">
            <div className="absolute left-0 top-2" ref={textRef}>
                {desc}
            </div>
            

            {mask ? 
                <InputMask name={name}
                    id={id}
                    type={type}
                    className="block border-b-2 font-semibold border-black/10 w-full outline-none p-2 transition-all duration-200 focus:border-black"
                    required={required}
                    mask={mask}
                    style={{ paddingLeft: width + 8 }} /> 
            :
                <input
                    name={name}
                    id={id}
                    type={type}
                    className="block border-b-2 font-semibold border-black/10 w-full outline-none p-2 transition-all duration-200 focus:border-black"
                    required={required}
                    style={{ paddingLeft: width + 8 }}
                />
            }
        </label>
    );
};

export default Input;
